"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.once = exports.addTimeout = void 0;
var addTimeout_1 = require("./addTimeout");
Object.defineProperty(exports, "addTimeout", { enumerable: true, get: function () { return addTimeout_1.addTimeout; } });
var once_1 = require("./once");
Object.defineProperty(exports, "once", { enumerable: true, get: function () { return once_1.once; } });
//# sourceMappingURL=index.js.map